module.exports = __webpack_public_path__ + "img/package-4.ecc91f4d.png";